import { render, staticRenderFns } from "./CategoryNode.vue?vue&type=template&id=f1cc8d50&scoped=true"
import script from "./CategoryNode.vue?vue&type=script&lang=js"
export * from "./CategoryNode.vue?vue&type=script&lang=js"
import style0 from "./CategoryNode.vue?vue&type=style&index=0&id=f1cc8d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cc8d50",
  null
  
)

export default component.exports